// extracted by mini-css-extract-plugin
export default {"RFLegend":"RFLegend---hFjSU","addButton":"addButton---TdWv_","linkButton":"linkButton---ebdFW","fullWidth":"fullWidth---rT1bh"};